import React, { useState, FormEvent } from 'react';
import { authApi } from '../services/api';

interface LoginFormProps {
    onLoginSuccess: () => void;
}

const LoginForm: React.FC<LoginFormProps> = ({ onLoginSuccess }) => {
    const [username, setUsername] = useState<string>('');
    const [password, setPassword] = useState<string>('');
    const [isSubmitting, setIsSubmitting] = useState<boolean>(false);
    const [error, setError] = useState<string | null>(null);

    const handleSubmit = async (event: FormEvent) => {
        event.preventDefault();
        setIsSubmitting(true);
        setError(null);

        try {
            await authApi.login(username, password);
            onLoginSuccess();
        } catch (err) {
            setError('Invalid username or password');
        } finally {
            setIsSubmitting(false);
        }
    };

    return (
        <div className="min-h-screen grid-bg ff-display text-[#141414] flex items-center justify-center p-6">
            <article className="relative bg-white border border-[#141414]/20 shadow-[0_1px_0_0_#141414] w-full max-w-sm">
                <span className="absolute -top-px -left-px h-3 w-3 border-t-2 border-l-2 border-[#141414]" />
                <span className="absolute -top-px -right-px h-3 w-3 border-t-2 border-r-2 border-[#141414]" />
                <span className="absolute -bottom-px -left-px h-3 w-3 border-b-2 border-l-2 border-[#141414]" />
                <span className="absolute -bottom-px -right-px h-3 w-3 border-b-2 border-r-2 border-[#141414]" />

                <div className="px-6 py-5 border-b border-[#141414]/15">
                    <div className="ff-mono text-[10px] uppercase tracking-[0.2em] text-[#e0461e]">
                        RFQ Processing System
                    </div>
                    <h2 className="ff-serif text-3xl leading-none mt-1">Sign in</h2>
                </div>

                <form onSubmit={handleSubmit} className="px-6 py-5">
                    {error && (
                        <div className="mb-4 border border-[#c2251a] bg-[#c2251a]/10 text-[#c2251a] px-3 py-2 ff-mono text-xs">
                            {error}
                        </div>
                    )}

                    <div className="mb-4">
                        <label
                            className="block ff-mono text-[10px] uppercase tracking-[0.2em] text-[#141414]/55 mb-1"
                            htmlFor="username"
                        >
                            Username
                        </label>
                        <input
                            id="username"
                            type="text"
                            value={username}
                            onChange={(e) => setUsername(e.target.value)}
                            className="w-full bg-white border border-[#141414]/25 focus:border-[#e0461e] outline-none px-2 py-1.5 ff-mono text-sm"
                            required
                        />
                    </div>

                    <div className="mb-6">
                        <label
                            className="block ff-mono text-[10px] uppercase tracking-[0.2em] text-[#141414]/55 mb-1"
                            htmlFor="password"
                        >
                            Password
                        </label>
                        <input
                            id="password"
                            type="password"
                            value={password}
                            onChange={(e) => setPassword(e.target.value)}
                            className="w-full bg-white border border-[#141414]/25 focus:border-[#e0461e] outline-none px-2 py-1.5 ff-mono text-sm"
                            required
                        />
                    </div>

                    <button
                        type="submit"
                        disabled={isSubmitting}
                        className="w-full ff-mono text-[10px] uppercase tracking-wider px-3 py-2 bg-[#141414] text-[#f3efe6] hover:bg-[#e0461e] disabled:opacity-50 transition"
                    >
                        {isSubmitting ? 'Logging in…' : 'Log in'}
                    </button>
                </form>
            </article>
        </div>
    );
};

export default LoginForm;
